const CheckIconRounded = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.48527 8.775L13.9603 0.3C14.1603 0.1 14.3978 0 14.6728 0C14.9478 0 15.1853 0.1 15.3853 0.3C15.5853 0.5 15.6853 0.7375 15.6853 1.0125C15.6853 1.2875 15.5853 1.525 15.3853 1.725L6.18527 10.925C5.98527 11.125 5.75193 11.225 5.48527 11.225C5.2186 11.225 4.98527 11.125 4.78527 10.925L0.485266 6.625C0.285266 6.425 0.189432 6.1875 0.197766 5.9125C0.206099 5.6375 0.310266 5.4 0.510266 5.2C0.710266 5 0.947766 4.9 1.22277 4.9C1.49777 4.9 1.73527 5 1.93527 5.2L5.48527 8.775Z"
        fill="white"
      />
    </svg>
  )
}

export default CheckIconRounded
